import { HTMLAttributes } from 'react';

import { useBootstrapApp } from 'hooks';

import { EntityDescription, EntitySelection } from './components';
import { useStyles } from './styles';

export function EntityHeader(
  props: HTMLAttributes<HTMLDivElement>,
): JSX.Element {
  const { rootStyle } = useStyles();
  const { entity } = useBootstrapApp();

  return (
    <div className={rootStyle} {...props}>
      {entity && (
        <>
          <EntityDescription entity={entity} />
          <EntitySelection />
        </>
      )}
    </div>
  );
}
